/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface JobDTO
 */
export interface JobDTO  {
    /**
     * 
     * @type {number}
     * @memberof JobDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof JobDTO
     */
    startTime?: Date;
    /**
     * 
     * @type {JobDTOProcessTypeEnum}
     * @memberof JobDTO
     */
    processType?: JobDTOProcessTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JobDTO
     */
    resumptionCursor?: string;
    /**
     * 
     * @type {JobDTOTenantEnum}
     * @memberof JobDTO
     */
    tenant?: JobDTOTenantEnum;
    /**
     * 
     * @type {JobDTOJobTypeEnum}
     * @memberof JobDTO
     */
    jobType?: JobDTOJobTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof JobDTO
     */
    errors?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDTO
     */
    successWithError?: number;
    /**
     * 
     * @type {number}
     * @memberof JobDTO
     */
    success?: number;
}


/**
 * @export
 */
export const JobDTOProcessTypeEnum = {
    Scopus: 'scopus',
    Wos: 'wos',
    Cr: 'cr',
    External: 'external',
    Dc: 'dc',
    Gvi: 'gvi',
    Enrich: 'enrich',
    Openalex: 'openalex',
    PersonLinking: 'personLinking'
} as const;
export type JobDTOProcessTypeEnum = typeof JobDTOProcessTypeEnum[keyof typeof JobDTOProcessTypeEnum];

/**
 * @export
 */
export const JobDTOTenantEnum = {
    Rub: 'RUB',
    Uwh: 'UWH',
    Hhu: 'HHU',
    Tudo: 'TUDO',
    Common: 'COMMON',
    Other: 'OTHER'
} as const;
export type JobDTOTenantEnum = typeof JobDTOTenantEnum[keyof typeof JobDTOTenantEnum];

/**
 * @export
 */
export const JobDTOJobTypeEnum = {
    Delta: 'delta',
    Ids: 'ids',
    Enrich: 'enrich',
    Noinfo: 'noinfo',
    PersonLinking: 'personLinking'
} as const;
export type JobDTOJobTypeEnum = typeof JobDTOJobTypeEnum[keyof typeof JobDTOJobTypeEnum];


/**
 * Check if a given object implements the JobDTO interface.
 */
export function instanceOfJobDTO(value: object): value is JobDTO {
    return true;
}

export function JobDTOFromJSON(json: any): JobDTO {
    return JobDTOFromJSONTyped(json, false);
}

export function JobDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
                  'processType': json['processType'] == null ? undefined : json['processType'],
                  'resumptionCursor': json['resumptionCursor'] == null ? undefined : json['resumptionCursor'],
                  'tenant': json['tenant'] == null ? undefined : json['tenant'],
                  'jobType': json['jobType'] == null ? undefined : json['jobType'],
                  'errors': json['errors'] == null ? undefined : json['errors'],
                  'successWithError': json['successWithError'] == null ? undefined : json['successWithError'],
                  'success': json['success'] == null ? undefined : json['success'],
    };
}

export function JobDTOToJSON(json: any): JobDTO {
    return JobDTOToJSONTyped(json, false);
}

export function JobDTOToJSONTyped(value?: JobDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'startTime': value['startTime']?.toISOString(),
        'processType': value['processType'],
        'resumptionCursor': value['resumptionCursor'],
        'tenant': value['tenant'],
        'jobType': value['jobType'],
        'errors': value['errors'],
        'successWithError': value['successWithError'],
        'success': value['success'],
    };
}


